module.exports = __webpack_public_path__ + "static/img/read.83bd1e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/read.png
// module id = 0cCp
// module chunks = 1